export const percentageCalculations = ['avg', 'min', 'max'];
export const isPercentageMetric = (fields, id) =>
  fields.some(
    (field) => field.id === id && field.config?.format === 'percentage'
  );
export const metricOperations = (options, fields, id) =>
  isPercentageMetric(fields, id)
    ? options
        .filter((option) => percentageCalculations.includes(option.value))
        .map((option, index) => ({ ...option, index }))
    : options;
export const percentageFieldDefaults = (name, id, form, fields) => {
  if (!name.endsWith('Field') || !isPercentageMetric(fields, id)) return {};
  const ref = name.slice(0, -5);
  return percentageCalculations.includes(form[ref + 'Calc'])
    ? {}
    : { [ref + 'Calc']: 'avg', [ref + 'CalcLabel']: 'Average' };
};
export const percentageValidation = (form, fields) => {
  for (const ref of ['number', 'size', 'color', 'shadow']) {
    if (
      isPercentageMetric(fields, form[ref + 'Field']) &&
      !percentageCalculations.includes(form[ref + 'Calc'])
    )
      return (
        'Percentage fields require Average, Minimum or Maximum for ' + ref + '.'
      );
  }
  return false;
};
